module.exports = __webpack_public_path__ + "static/media/va.18d695af.png";